import React, { useState, useContext } from "react";
import { Col, Form } from "react-bootstrap";
import { SettingsContext } from './AccountSettingsButton'
import jsDig from "utils/jsDig.js";
import { v4 as uuidv4 } from "uuid";

export default function ScriptBoxes(props) {

  const context = useContext(SettingsContext);
  const [localKeywords, setLocalKeywords] = useState(context.excludeNbInShoppingKeywords);

  const deleteKeyword = (e, kwNum) => {
    e.preventDefault();
    const {[kwNum]: deletedValue, ...remainingKeywords} = context.excludeNbInShoppingKeywords;
    context.setExcludeNbInShoppingKeywords(remainingKeywords);
  };

  const handleAddKeyword = (e) => {
    e.preventDefault();
    // context.excludeNbInShoppingKeywords is an object with numeric keys
    const newKey = uuidv4()
    const newKeywords = { ...context.excludeNbInShoppingKeywords, [newKey]: "" }; // Add a new entry with an empty string or a default value
    context.setExcludeNbInShoppingKeywords(newKeywords);
  };

  const handleLocalChange = (key, value) => {
    setLocalKeywords(prevKeywords => ({
        ...prevKeywords,
        [key]: value
    }));
};

    const [youtubeChannelExcluderCountries, setYoutubeChannelExcluderCountries] = useState(jsDig(["client_account", "scripts", "youtube_channel_excluder", "allowed_countries"], context));
    const [youtubeChannelExcluderImpressionsThreshold, setYoutubeChannelExcluderImpressionsThreshold] = useState(jsDig(["client_account", "scripts", "youtube_channel_excluder", "impressions_threshold"], context));
    const [youtubeChannelExcluderGoogleSheet, setYoutubeChannelExcluderGoogleSheet] = useState(jsDig(["client_account", "scripts", "youtube_channel_excluder", "google_sheet"], context));



    //onchange checkboxes

    const handleCheckbox = (e, scriptName) => {
      if (scriptName == "text_converting_query_mining_script") {
        context.setTextConvertingQueryMiningScript(e.target.checked);
      } else if (scriptName == "em_bm_negative_overlap_script") {
        context.setEmBmNegativeOverlapScript(e.target.checked);
      }
      else if (scriptName == "negative_dsa_sync_script") {
        context.setNegativeDsaSyncScript(e.target.checked);
      }
      else if (scriptName == "keyword_cannibalization_script") {
        context.setKeywordCannibalizationScript(e.target.checked);
      }
      else if (scriptName == "youtube_channel_excluder") {
        context.setYoutubeChannelExcluder(e.target.checked);
      }
      else if (scriptName == "exclude_nb_in_shopping") {
        context.setExcludeNbInShopping(e.target.checked);
      }
    }


    //onchange inputs
    
    const handleYoutubeChannelExcluderCountries = (e) => {
      setYoutubeChannelExcluderCountries(e.target.value);
    }
    const handleYoutubeChannelExcluderTimeRange = (e) => {
      context.setYoutubeChannelExcluderTimeRange(e.target.value);
    }
    const handleYoutubeChannelExcluderGoogleSheet = (e) => {
      setYoutubeChannelExcluderGoogleSheet(e.target.value);
    }

    const handleYoutubeChannelExcluderImpressionsThreshold = (e) => {
      setYoutubeChannelExcluderImpressionsThreshold(e.target.value);
    }


//onblur

const handleGoogleSheetsBlur = () => {
  context.setYoutubeChannelExcluderGoogleSheet(youtubeChannelExcluderGoogleSheet);
};
const handleAllowedCountriesBlur = () => {
  context.setYoutubeChannelExcluderCountries(youtubeChannelExcluderCountries);
};
const handleImpressionsThresholdBlur = () => {
  context.setYoutubeChannelExcluderImpressionsThreshold(youtubeChannelExcluderImpressionsThreshold);
};

const handleBlur = () => {
  context.setExcludeNbInShoppingKeywords(localKeywords);
};

  return (
    <>
      {props.scripts.map((script) => {
        return (
          <React.Fragment key={script.name}>
            {script.name == "exclude_nb_in_shopping" ? (
              <Col className="script-box-wide mb-2 px-2">
                <div className="p-3 h-100 script-box-bg">
                  <div className="mb-2">
                      <div className="lite-checkbox-container">
                      <input
                        type="checkbox"
                        className="lite-checkbox "
                        id={`scripts_${script.name}`}
                        name={`scripts[exclude_nb_in_shopping][enabled]`}
                        onChange={(e) => {handleCheckbox(e, "exclude_nb_in_shopping")}}
                        defaultChecked={jsDig(["excludeNbInShopping" ], context) == "1" ? true: false}                       
                        />
                       <label className="custom-bel" htmlFor={`scripts_${script.name}`}>{script.title}</label>
                        </div>
                  </div>
                  <div>
                    <p className="f14   pb-3">
                      {script.desc}
                    </p>
                  </div>
                  <div>
                    <p className="f14   pb-1">Please add branded keywords - keywords should only match variations of the company name, no long-tail keywords:</p>
                    <p className="f12   pb-3"><i>All keywords with more than 0 clicks in the past 30 days will be analyzed</i></p>
                  </div>
                  <div className="d-flex" style={{gap: "12px"}}>
                    <div className="script-list d-flex flex-wrap" style={{columnGap: "12px"}}>
                      {Object.keys(context.excludeNbInShoppingKeywords).map((kwNum, i) => {
                        return (
                          <div key={i} className="d-flex align-items-center pb-2" style={{gap: "8px"}}>
                            <span className="list-number d-none" style={{minWidth: "22px"}}>{kwNum}.</span>
                              <input
                                name={`scripts[exclude_nb_in_shopping][keyword][${kwNum}]`}
                                value={localKeywords[kwNum]}
                                onChange={(e) => handleLocalChange(kwNum, e.target.value)}
                                onBlur={handleBlur}
                              />
                            <span className="delete-icon" style={{cursor: "pointer"}} onClick={(e) => deleteKeyword(e, kwNum)}>
                              <i className="fas fa-trash-alt" style={{fontSize: "12px"}}></i>
                            </span>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                  <button className="green-button" onClick={(e) => handleAddKeyword(e)}>Add +</button>
                </div>
              </Col>
            ) : (script.name == "youtube_channel_excluder") ? (
              <Col className="script-box-wide mb-2 px-2">
                <div className="p-3 h-100 script-box-bg">
                  <div className="mb-2">
                  <div className="lite-checkbox-container">
                      <input
                        type="checkbox"
                        className="lite-checkbox "
                        id="scripts_youtube_channel_excluder"
                        name={`scripts[youtube_channel_excluder][enabled]`}
                        onChange={(e) => {handleCheckbox(e, "youtube_channel_excluder")}}
                        defaultChecked={jsDig(["youtubeChannelExcluder" ], context) == "1" ? true: false}                    
                        />
                       <label className="custom-bel" htmlFor="scripts_youtube_channel_excluder">{script.title}</label>
                        </div>          
                  </div>
                  <div>
                    <p className="f14   pb-3">{script.desc}</p>
                  </div>
                  <div>
                    <p className="f14   pb-1">Please create a copy of <a href="https://docs.google.com/spreadsheets/d/1kzY39AwTnidat-xzFpcVcs7kPavNXNbjVrm-qPoJPCk" target="_blank" style={{textDecoration: "underline"}}>this</a> google sheet before enabling this script.</p>
                    <p className="f12   pb-3"><i>Edit access must be granted to support@digitalposition.com</i></p>
                  </div>
                  <div className="d-flex flex-column" style={{gap: "8px"}}>
                    <Form.Group controlId="youtube_channel_excluder_google_sheet" className="mb-0">
                      <Form.Label className="f12 font-weight-bold pb-2  ">Google Sheet</Form.Label>
                        <Form.Control
                          className="d-inline"
                          size="sm"
                          name="scripts[youtube_channel_excluder][google_sheet]"
                          defaultValue={context.youtubeChannelExcluderGoogleSheet ? context.youtubeChannelExcluderGoogleSheet : ""}
                          onChange={handleYoutubeChannelExcluderGoogleSheet}
                          onBlur={handleGoogleSheetsBlur}
                          placeholder="https://docs.google.com/spreadsheets/..."
                        />
                    </Form.Group>
                    <Form.Group controlId="youtube_channel_excluder_allowed_countries" className="mb-0">
                      <Form.Label className="f12 font-weight-bold  ">Allowed Countries</Form.Label>
                      <p className="f12   pb-2"><i>Please supply a regex formula to specfify which countries you would like to whitelist. (E.g. <b>^US|UK|CA$</b>) </i></p>
                        <Form.Control
                          className="d-inline"
                          size="sm"
                          name="scripts[youtube_channel_excluder][allowed_countries]"
                          defaultValue={context.youtubeChannelExcluderCountries ? context.youtubeChannelExcluderCountries : ""}
                          onChange={handleYoutubeChannelExcluderCountries}
                          onBlur={handleAllowedCountriesBlur}
                          placeholder="^US$"
                        />
                    </Form.Group>
                    <Form.Group controlId="youtube_channel_excluder_impressions_time_range" className="mb-0">
                      <Form.Label className="f12 font-weight-bold  ">Impressions Time Range</Form.Label>
                      <p className="f12   pb-2"><i>Select a predefined time range.</i></p>
                      <div className="select-wrapper">
                        <select
                          name="scripts[youtube_channel_excluder][impressions_time_range]"
                          defaultValue={context.youtubeChannelExcluderTimeRange ? context.youtubeChannelExcluderTimeRange : "LAST_7_DAYS"}
                          onChange={handleYoutubeChannelExcluderTimeRange}
                          placeholder="LAST_7_DAYS"
                        >
                          <option value="LAST_7_DAYS">LAST_7_DAYS</option>
                          <option value="LAST_14_DAYS">LAST_14_DAYS</option>
                          <option value="LAST_30_DAYS">LAST_30_DAYS</option>
                          <option value="LAST_90_DAYS">LAST_90_DAYS</option>
                        </select>
                        </div>
                    </Form.Group>
                    <Form.Group controlId="youtube_channel_excluder_impressions_threshold" className="mb-0">
                      <Form.Label className="f12 font-weight-bold  ">Impressions Threshold</Form.Label>
                      <p className="f12   pb-2"><i>Minimum number of impressions to consider a channel for exclusion.</i></p>
                        <Form.Control
                          className="d-inline"
                          size="sm"
                          name="scripts[youtube_channel_excluder][impressions_threshold]"
                          defaultValue={context.youtubeChannelExcluderImpressionsThreshold ? context.youtubeChannelExcluderImpressionsThreshold : ""}
                          onChange={handleYoutubeChannelExcluderImpressionsThreshold}
                          onBlur={handleImpressionsThresholdBlur}
                          placeholder="Default: 10"
                        />
                    </Form.Group>
                  </div>
                </div>
              </Col>
              ) : (
              <Col key={script.name} className="script-box mb-2 px-2">
                <div className="p-3 h-100 script-box-bg">
                  <div className="mb-2">
                      <div className="lite-checkbox-container">
                      <input
                        type="checkbox"
                        className="lite-checkbox "
                        id={`scripts_${script.name}`}
                        name={`scripts[${script.name}]`}
                        onChange={(e) => {handleCheckbox(e, script.name)}}
                        defaultChecked={
                          script.name == "text_converting_query_mining_script" ? context.textConvertingQueryMiningScript == "1" ? true : false :
                          script.name == "em_bm_negative_overlap_script" ? context.emBmNegativeOverlapScript == "1" ? true : false :
                          script.name == "negative_dsa_sync_script" ? context.negativeDsaSyncScript == "1" ? true : false :
                          script.name == "keyword_cannibalization_script" ? context.keywordCannibalizationScript == "1" ? true : false :
                          script.name == "youtube_channel_excluder" ? context.youtubeChannelExcluder == "1" ? true : false : false}        
                        />
                       <label className="custom-bel" htmlFor={`scripts_${script.name}`}>{script.title}</label>
                        </div>

                  </div>
                  <div>
                    <p className="f14  ">{script.desc}</p>
                  </div>
                </div>
              </Col>
            )}
          </React.Fragment>
        );
      })}
    </>
  )
}
